import * as App from '../../app';
import { Canvas, CANVAS_SCALE } from '../../lib/classes';
export function drawBackground(size) {
    size = size - 20;
    var winBg = new Canvas(size, size);
    var ctx = winBg.ctx;
    var count = 18;
    var angleDelta = (2 * Math.PI) / count;
    var center = Math.ceil(size / 2) * CANVAS_SCALE;
    var radius = size * CANVAS_SCALE;
    winBg.fillAll(IS_ULTRA ? '#1c596b' : App.themes.get().gridBg2);
    ctx.fillStyle = App.themes.get().cell;
    for (var i = 0; i < count; i += 2) {
        ctx.beginPath();
        ctx.moveTo(center, center);
        ctx.arc(center, center, radius, i * angleDelta, (i + 1) * angleDelta);
        ctx.moveTo(center, center);
        ctx.closePath();
        ctx.fill();
    }
    return "url(\"".concat(winBg.canvas.toDataURL(), "\")");
}
